import { render, staticRenderFns } from "./Desarrollos.vue?vue&type=template&id=1701d56e&"
import script from "./Desarrollos.vue?vue&type=script&lang=js&"
export * from "./Desarrollos.vue?vue&type=script&lang=js&"
import style0 from "./Desarrollos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports